export default __webpack_public_path__ + "static/media/Icon-doctor_referral-new.504cefd6.svg";